module.exports = __webpack_public_path__ + "img/circles4.5ec284a0.png";